<template>

  <div>
    <v-data-table :headers="headers" :items="videos" hide-actions="hide-actions" no-data-text="No videos yet">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.authorPreferredUsername }}</td>
        <td>{{ props.item.type }}</td>
        <td>{{ props.item.club1Name }}</td>
        <td>{{ props.item.club2Name }}</td>
        <td>{{ props.item.hitCounter }}</td>
        <td>
          <v-icon title="Remove" @click="removeVideo(props.item)">mdi-close-circle</v-icon>
        </td>
      </template>
    </v-data-table>
    <v-layout justify-end="justify-end" row="row">
      <v-flex xs4="xs4">
        <v-text-field label="Video ID" v-model="currentID"></v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs4="xs4">
        <v-text-field label="Club that scores (1 or 2)" v-model="currentScorer"></v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs3="xs3">
        <v-btn @click="addVideo(currentID)">Add</v-btn>
      </v-flex>
    </v-layout>
    <div class="error-message">{{ error }}</div>
    <v-dialog v-model="dialog" :persistent="true" max-width="400px">
      <v-card>
        <v-card-title class="headline">Warning</v-card-title>
        <v-card-text>
          <div class="warning-message" v-for="(warning, index) of warnings" :key="index">- {{ warning }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false">Cancel</v-btn>
          <v-btn @click="confirm(currentID)">Add anyway</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'TopActionVideoPicker',
  props: ['value', 'item'],
  data: () => ({
    headers: [
      {
        text: 'ID',
        value: 'id'
      },
      {
        text: 'Author',
        value: 'authorID'
      },
      {
        text: 'Type',
        value: 'type'
      },
      {
        text: 'Club 1',
        value: 'club1Name'
      },
      {
        text: 'Club 2',
        value: 'club2Name'
      },
      {
        text: 'Views',
        value: 'hitCounter'
      },
      {
        text: 'Action',
        sortable: false
      }
    ],
    items: [],
    completeItems: [],
    currentID: '',
    currentScorer: null,
    error: '',
    warnings: [],
    dialog: null
  }),
  computed: {
    ...mapGetters(['videoByIDs']),
    videos: {
      get () {
        return this.videoByIDs(this.items)
      }
    }
  },
  methods: {
    addVideo (id) {
      if (this.videos.find(v => v.id === id)) {
        this.currentID = ''
        return
      }
      this.$store.dispatch('getVideo', id)
        .then(video => {
          this.warnings = []
          if (video.sportID !== this.item.sportID) {
            this.warnings.push('This video is from a different sport')
          }
          if (!video.matchID) {
            this.warnings.push('This video is not associated with any match')
          }
          if (!this.currentScorer) {
            this.warnings.push('Please add scorer index')
          }

          if (this.warnings.length === 0) {
            this.confirm(id, this.currentScorer)
          } else {
            this.dialog = true
          }
        })
        .catch(err => {
          this.error = 'Couldn\'t find the video'
          console.error(err)
        })
    },
    confirm (itemid, scorerindex) {
      this.items.push(itemid)
      this.completeItems.push({
        id: itemid,
        scorer: parseInt(scorerindex)
      })
      this.dialog = false
      this.error = ''
      this.currentID = ''
      this.currentScorer = null
      this.update()
    },
    removeVideo (item) {
      this.items = this.items.filter(i => i !== item.id)
      this.completeItems = this.completeItems.filter(i => i.id !== item.id)
      this.update()
    },
    update () {
      this.$emit('input', this.completeItems)
    }
  },
  watch: {
    value: {
      deep: true,
      handler () {
        if (this.value) {
          for (const item of this.value) {
            if (this.items.indexOf(item.id) === -1) {
              this.items.push(item.id)
            }
          }
        } else {
          this.items = []
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.error-message {
  color: red;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/TopActionVideoPicker.vue